// extracted by mini-css-extract-plugin
export default {"tooltipContent":"yVGxN7Jfel2ig7UNOB9V"};